import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, of, switchMap } from 'rxjs';
import { AuthService, browserAssuranceRequestHeader } from './services/auth.service';

export const authTokenInterceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const authService = inject(AuthService);
  if (request.headers.has(browserAssuranceRequestHeader)) {
    return next(request.clone({
      headers: request.headers.delete(browserAssuranceRequestHeader),
      withCredentials: true,
    }));
  }

  const sessionAwareRequest = authService.shouldAttachBrowserSessionCredentials(request.url) && !request.withCredentials
    ? request.clone({ withCredentials: true })
    : request;

  if (sessionAwareRequest.headers.has('Authorization')) {
    return next(sessionAwareRequest);
  }

  return from(authService.getAccessTokenForRequest(sessionAwareRequest.url)).pipe(
    // Only token acquisition can fall back to the browser session. Catching downstream
    // HTTP failures here would replay writes that may already have been committed.
    catchError((error) => {
      console.warn('Continuing request without a bearer token after auth acquisition failed.', error);
      return of(null);
    }),
    switchMap((token) => {
      if (!token) {
        return next(sessionAwareRequest);
      }

      return next(sessionAwareRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      }));
    }),
  );
};
